/**
 * DanceNode.tsx
 * Danceカードのビューコンポーネント
 * 選んだダンス名を表示し、設定はダイアログで行う
 */
import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { DanceNode } from '../../types';
import { getDanceLabel } from '../../config/danceMotions';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import { CardShell } from '../CardShell';

export const DanceNodeView = memo(function DanceNodeView({ data }: NodeProps<DanceNode>) {
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <CardShell
      kind="dance"
      accent="rose"
      title={getNodeDisplayLabel('dance', displayLanguage)}
      summary={getDanceLabel(data.motionId) ?? ''}
    >
      <Handle type="target" position={Position.Left} className="!bg-rose-500" />
      <Handle type="source" position={Position.Right} className="!bg-rose-500" />
    </CardShell>
  );
});
